import EventActionProto from '../event-action-proto';

module.exports = class EventQuickNotesReset extends EventActionProto {

    constructor(uid, data) {
        super(uid, data);
    }

    validate() {
        return true;
    }

    process() {
        gd.session.quickNotes = this.data.notes;
        super.process();
    }
};

